(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adriana-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const viewport = section.querySelector('.adriana-reviews__viewport');
      const track = section.querySelector('[data-review-track]');
      const slides = [...section.querySelectorAll('[data-review-slide]')];
      const dots = [...section.querySelectorAll('[data-review-dot]')];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Math.max(2000, Number(section.dataset.interval) || 2000);
      let current = 0;
      let timer;

      const getLastIndex = () => {
        const slideWidth = slides[0].getBoundingClientRect().width;
        const visible = Math.max(1, Math.floor((viewport.clientWidth + 1) / slideWidth));
        return Math.max(0, slides.length - visible);
      };
      const show = (index) => {
        const lastIndex = getLastIndex();
        current = index > lastIndex ? 0 : index < 0 ? lastIndex : index;
        track.style.transform = `translateX(-${slides[current].offsetLeft}px)`;
        slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === current ? 'false' : 'true'));
        dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (!reduceMotion && slides.length > 1) timer = window.setInterval(() => show(current + 1), interval);
      };

      section.querySelector('[data-review-previous]').addEventListener('click', () => { show(current - 1); start(); });
      section.querySelector('[data-review-next]').addEventListener('click', () => { show(current + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.reviewDot)); start(); }));
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      window.addEventListener('resize', () => show(current));
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      show(0);
      start();
    };
    document.querySelectorAll('[data-adriana-reviews]').forEach(setup);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-adriana-reviews]').forEach(setup));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adriana-video-duo"] && !Shopify.designMode) return;
  try {
    
  if (!window.adrianaVideoThumbnailsReady) {
    window.adrianaVideoThumbnailsReady = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-adriana-video-play]');
      if (!button) return;
      const media = button.closest('.adriana-video__media');
      const video = media && media.querySelector('video');
      if (video) video.play();
    });
    document.addEventListener('play', (event) => {
      if (event.target.matches('.adriana-video__player')) event.target.closest('.adriana-video__media').classList.add('is-playing');
    }, true);
    document.addEventListener('pause', (event) => {
      if (event.target.matches('.adriana-video__player')) event.target.closest('.adriana-video__media').classList.remove('is-playing');
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adriana-video-text"] && !Shopify.designMode) return;
  try {
    
  if (!window.adrianaVideoTextReady) {
    window.adrianaVideoTextReady = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-video-text-play]');
      if (!button) return;
      const media = button.closest('.adriana-video-text__media');
      const video = media && media.querySelector('video');
      if (video) video.play();
    });
    document.addEventListener('play', (event) => {
      if (event.target.matches('.adriana-video-text__player')) event.target.closest('.adriana-video-text__media').classList.add('is-playing');
    }, true);
    document.addEventListener('pause', (event) => {
      if (event.target.matches('.adriana-video-text__player')) event.target.closest('.adriana-video-text__media').classList.remove('is-playing');
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
